import Vue from 'vue'
import {
  Button,
  Form,
  Field,
  NavBar,
  Toast,
  Tabbar,
  TabbarItem,
  Tab,
  Tabs,
  Sidebar,
  SidebarItem,
  Sticky,
  Popover,
  ActionSheet,
  Grid,
  GridItem,
  List,
  Card,
  SubmitBar,
  Stepper,
  AddressList,
  AddressEdit,
  NoticeBar,
  PullRefresh,
  Cell,
  Image,
  Icon,
  Popup,
  ImagePreview,
  CellGroup,
  Lazyload,
  Search,
  Loading,
  Divider,
  Tag,
  Row,
  Col,
  Dialog,
  DatetimePicker,
  Uploader,
  SwipeCell,
  GoodsAction,
  GoodsActionIcon,
  GoodsActionButton,
  Checkbox,
  CheckboxGroup,
  RadioGroup,
  Radio,
} from 'vant'
Vue.prototype.$toast = Toast
Vue.prototype.$dialog = Dialog
Vue.prototype.$imagePreview = ImagePreview
Vue.use(Button)
  .use(NavBar)
  .use(Form)
  .use(Field)
  .use(Tabbar)
  .use(TabbarItem)
  .use(Tab)
  .use(Tabs)
  .use(Sidebar)
  .use(SidebarItem)
  .use(Sticky)
  .use(Popover)
  .use(ActionSheet)
  .use(Grid)
  .use(GridItem)
  .use(List)
  .use(Card)
  .use(SubmitBar)
  .use(Stepper)
  .use(AddressList)
  .use(AddressEdit)
  .use(NoticeBar)
  .use(PullRefresh)
  .use(Cell)
  .use(CellGroup)
  .use(Image)
  .use(Icon)
  .use(Popup)
  .use(Lazyload)
  .use(Search)
  .use(Loading)
  .use(Divider)
  .use(Row)
  .use(Col)
  .use(Tag)
  .use(Dialog)
  .use(DatetimePicker)
  .use(Uploader)
  .use(SwipeCell)
  .use(GoodsAction)
  .use(GoodsActionIcon)
  .use(GoodsActionButton)
  .use(Checkbox)
  .use(CheckboxGroup)
  .use(RadioGroup)
  .use(Radio)
